import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {LeftPanelOutput, Page, SubPage, Vendor} from '@entities/left-panel/left-panel.interface';
import {GoParams} from '@entities/router/router.interfaces';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Store} from '@ngrx/store';
import {AppState} from '@store';
import {LeftPanelActions} from '@store/left-panel/actions';
import {leftPanelSelector} from '@store/left-panel/selectors';
import {routerActions} from '@store/route/actions';
import {Observable} from 'rxjs';

/**
 * 'LeftPanelContainer' class definition.
 */
@UntilDestroy()
@Component({
	selector: 'left-panel',
	template: `
		<left-panel-component
			[pages]="pages$ | async"
			[activePage]="activePage$ | async"
			[activeSubPage]="activeSubPage$ | async"
			[activeVendor]="activeVendor$ | async"
			(choosePage)="onChoosePage($event)"
		>
		</left-panel-component>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftPanelContainer implements OnInit {
	/**
	 * Auxiliary variable for accessing to Observable of active page.
	 */
	public readonly activePage$: Observable<Page>;
	/**
	 * Auxiliary variable for accessing to Observable of active sub page.
	 */
	public readonly activeSubPage$: Observable<SubPage>;
	/**
	 * Auxiliary variable for accessing to Observable of active vendor.
	 */
	public readonly activeVendor$: Observable<Vendor>;
	/**
	 * Auxiliary variable for accessing to Observable of pages.
	 */
	public readonly pages$: Observable<Page[]>;

	/**
	 * Constructor for LeftPanelContainer.
	 */
	constructor(private store: Store<AppState>) {
		this.activePage$ = this.store.select(leftPanelSelector.activePage);
		this.activeSubPage$ = this.store.select(leftPanelSelector.activeSubPage);
		this.activeVendor$ = this.store.select(leftPanelSelector.activeVendor);
		this.pages$ = this.store.select(leftPanelSelector.pages);
	}

	/**
	 * Default Angular framework 'ngOnInit' Lifecycle hook.
	 * @returns {void}
	 */
	public ngOnInit(): void {
		this.store.dispatch(LeftPanelActions.load.requested());
	}

	/**
	 * On choose page.
	 * @param {LeftPanelOutput} output
	 * @returns {void}
	 */
	public onChoosePage(output: LeftPanelOutput): void {
		let url = `${output.page.url}`;
		if (output.subPage) {
			url = output.vendor ? `${url}/${output.subPage.url}/${output.vendor.url}` : `${url}/${output.subPage.url}`;
		}
		const payload: GoParams = {url};
		this.store.dispatch(routerActions.go({payload}));
	}
}
